<script lang="ts">
  import AuthLayout from "./AuthLayout.svelte";
  import Banner from "$lib/components/Banner.svelte";
  import Button from "$lib/components/Button.svelte";
  import { router } from "../../router.svelte";

  // Stable code + correlation id only — never a policy leak or assertion detail.
  const code = $derived(router.match.query.get("code") ?? "saml_authentication_failed");
  const ref = $derived(router.match.query.get("ref") ?? undefined);

  const MESSAGES: Record<string, string> = {
    saml_authentication_failed: "Your identity provider could not complete sign-in.",
    saml_unavailable: "SSO is not available for this organization right now.",
    saml_config_required: "This organization's SSO configuration is incomplete.",
    session_expired: "The sign-in attempt expired. Please try again."
  };
  const message = $derived(MESSAGES[code] ?? "We couldn't sign you in with SSO. Please try again.");
</script>

<AuthLayout title="Sign-in problem">
  <Banner tone="error" title="SSO sign-in failed" correlationId={ref}>
    {message}
  </Banner>
  <Button href="/login" fullWidth>Back to sign in</Button>
</AuthLayout>
